import Footer from "../components/FooterComponents/Footer";
import SEO from "../components/SEO";
import { seoConfig } from "../data/seoConfig";

const About = () =>{
    return(
        <>
        <SEO {...seoConfig.about} />
         <div className="container mt-0 mt-md-5" id="about">
            <div className="row align-items-stretch">
                <div className="col-12 col-md-6 col-lg-6">
                   <h1 className="text-grey fw-bolder mt-5">
                        About RK Infosys
                    </h1>
                    <p className="text-grey  mt-4">
                         Since its establishment in 2021, RK Infosys has been committed to delivering innovative software solutions that empower businesses. We specialize in custom software development, web design, mobile app development, and professional internship programs for aspiring developers.
                     </p>
                    <p className="text-grey mt-4">
                         Our team of experienced developers and designers brings together expertise in frontend development, backend development, and full-stack solutions. We tailor our services including project training and technical support to meet the unique requirements of businesses across all industries.
                     </p>
                    <p className="text-grey mt-4">
                         We are dedicated to streamlining operations, strengthening digital presence, enabling consistent business growth, and nurturing the next generation of software developers through our internship programs.
                     </p>
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-4 mt-md-0 d-flex">
                    <img src="/assets/images/team/team-2.jpg"
                        className="w-100 rounded about-page-image"
                        alt="RK Infosys - Software Development Team"
                        loading="lazy"/>
                </div>
            </div>
        </div>
        <Footer />
        </>
    )
}
export default About;